module.exports = __webpack_public_path__ + "static/img/14000038.663fc222.png";